import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

import Filtering from "./Filtering";
import Graph from "./Graph";
import Loading from "../general/Loading";

class CertificationsAnalytics extends React.Component {
  state = { data: [], loading: false, certification: "", location: "" };

  componentWillMount() {
    this.loadData();
  }

  handlerChangeLocation = e =>
    this.setState({ location: e.target.value }, this.loadData);
  handlerChangeCertification = e =>
    this.setState({ certification: e.target.value }, this.loadData);

  loadData = () => {
    if (this.state.loading) {
      return;
    }

    this.setState({ loading: true });

    const params = [];

    if (this.state.certification) {
      params.push(`certification_id=${this.state.certification}`);
    }

    if (this.state.location) {
      params.push(`location_id=${this.state.location}`);
    }

    axios
      .get(`/certifications_analytics.json?${params.join("&")}`)
      .then(({ data }) => {
        this.setState({ data: data, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { loading, data, location, certification } = this.state;
    const { locations, certifications } = this.props;

    return (
      <div>
        <h1>Certifications Analytics</h1>

        <Filtering
          locations={locations}
          location={location}
          certifications={certifications}
          certification={certification}
          onChangeLocation={this.handlerChangeLocation}
          onChangeCertification={this.handlerChangeCertification}
        />

        {loading ? <Loading loading={true} /> : <Graph data={data} />}

        {data.length === 0 && !loading ? (
          <div className="grey-text text-center">
            <p className="grey-text">No certifications</p>
          </div>
        ) : null}
      </div>
    );
  }
}

CertificationsAnalytics.propTypes = {
  certifications: PropTypes.array.isRequired,
  locations: PropTypes.array.isRequired
};

export default CertificationsAnalytics;
